import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useRef } from "react";
import { usePageState } from "../PageContext";
import * as layouts from "./layouts";
import * as steppers from "./steppers";
export const FormPages = memo(({ pages, header, modalClick, modalCloseMode, stepper, formIsDisabled, scrollToTop = true }) => {
    const { step } = usePageState();
    const { layout, ...page } = pages[step];
    // Fixes focus after navigating
    const topDivRef = useRef(null);
    useEffect(() => {
        if (!scrollToTop) {
            return;
        }
        if (topDivRef.current) {
            topDivRef.current.scrollIntoView();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.location.href, scrollToTop]);
    const PageComponent = layout && layouts[layout] ? layouts[layout] : layouts.Wizard;
    const StepperComponent = steppers && stepper && steppers[stepper];
    return (_jsxs(_Fragment, { children: [_jsx("div", { id: "scrollToTopDiv", ref: topDivRef }), StepperComponent && _jsx(StepperComponent, {}), _jsx(PageComponent, { header: header, ...page, modalClick: modalClick, modalCloseMode: modalCloseMode, stepper: stepper, formIsDisabled: formIsDisabled })] }));
});
//# sourceMappingURL=FormPages.js.map